import React from 'react';
import styled from 'styled-components';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const RadioFrame = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    background: #f8f9fb;
    border: 1px solid #e0e4ea;
    border-radius: 6px;
    padding: 4px 16px;
    transition: border-color 0.15s ease;

    .MuiFormControlLabel-label {
        font-size: 0.95rem;
        color: #555;
    }
`;

const AdminClubKioskInfo = ({
    selectClubInfo,
    setKiosk,
    setChangeKioskInfo
}) => {

    const onChangeKiosk = (e)=>{
        setKiosk(parseInt(e.target.value))
    }

  return selectClubInfo ? (
    <SettingCard title="키오스크 설정">
        <SettingInfoBox>
            <SettingInfoLabel>활성화 유무</SettingInfoLabel>
            <SettingInfoValue>
                <RadioFrame>
                    <RadioGroup
                        aria-label="type"
                        name="viewType"
                        value={selectClubInfo.kiosk}
                        onChange={onChangeKiosk}
                        row={true}
                    >
                        <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="활성화"
                        />
                        <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="비활성화"
                        />
                    </RadioGroup>
                </RadioFrame>
            </SettingInfoValue>
        </SettingInfoBox>
        <CardFooter>
            <SaveButton active={selectClubInfo.isKioskEdit} onClick={() => setChangeKioskInfo()}>
                수정하기
            </SaveButton>
        </CardFooter>
    </SettingCard>
  ) : null;
};

export default React.memo(AdminClubKioskInfo);
